module.exports = "./img/98074d067db1868caee63d1a716717c9.jpg";